import script from "./BookingTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./BookingTemplate.vue?vue&type=style&index=0&id=f6199dd6&scoped=true&lang=scss"
import "./BookingTemplate.vue?vue&type=style&index=1&id=f6199dd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6199dd6"]])

export default __exports__